import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { shouldShowField, validateField } from '../../../../../components/InputField/helper';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD_NUM } from '../helper';

const CorporateAccountUpgrade = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    applicationForm,
    isForEDD,
    handleChange,
    handlePrev,
    editMode
}) => {
    const { showError } = useContext(DialogContext);

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                showError(fieldError);
                return false;
            }
        }
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            _.set(updatedErrors, field, errorMsg);
            return updatedErrors;
        })
    }

    return (
        <div className="row">
            <div className="col-12">
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3 mb-4'>Corporate Account Upgrade</h2>
                
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["usesOwnFunds"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('usesOwnFunds', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["reasonsForLimits"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('reasonsForLimits', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["reasonsForLimitsOthers"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('reasonsForLimitsOthers', errorMsg)}
                    isForEDD={isForEDD}
                />


                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["mainDrivers"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('mainDrivers', errorMsg)}
                    isForEDD={isForEDD}
                />

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.CorporateAccountUpgrade}
                        hideSubmitButton={hideButtons}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.CorporateAccountUpgrade}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default CorporateAccountUpgrade;
